<template>
    <div class="grid md:grid-cols-4 gap-4 flex-1 xl:grid-cols-12">
        <div class="relative md:col-span-2 xl:col-span-3">
            <div
                class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none text-opacity-50"
                :class="'text-' + isCustomColor(layoutOptions.text_color) ? 'custom-text' : layoutOptions.text_color"
            >
                <svg
                    v-if="layoutOptions.icons === 'bold'"
                    class="w-4 h-4"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path fill="none" d="M0 0h24v24H0z"/>
                    <path
                        d="M11 2c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9zm8.485 16.071l2.829 2.828-1.415 1.415-2.828-2.829 1.414-1.414z"/>
                </svg>
                <svg
                    v-else
                    class="w-4 h-4"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path fill="none" d="M0 0h24v24H0z"/>
                    <path
                        d="M11 2c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9zm0 16c3.867 0 7-3.133 7-7 0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7zm8.485.071l2.829 2.828-1.415 1.415-2.828-2.829 1.414-1.414z"/>
                </svg>
            </div>
            <input
                v-model="searchQuery"
                type="text"
                name="search"
                id="search"
                class="block pl-9 w-full text-sm rounded border-gray-300 transition-shadow focus:ring-0 focus:border-gray-400"
                :placeholder="portalTranslationSettings.search || 'Search'"
                @keyup.enter="fetchData"
            >
        </div>

        <template v-for="(filter, fieldName) in filterList">
        <!-- select -->
            <div
                v-if="filter.type === 'select'"
                class="flex relative md:col-span-2 xl:col-span-3">
                <div class="relative w-full">
                    <span
                        :key="filter.type + '-' + filter.label"
                        class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none text-opacity-50"
                        :class="'text-' + isCustomColor(layoutOptions.text_color) ? 'custom-text' : layoutOptions.text_color"
                    >
                        <svg
                            v-if="layoutOptions.icons === 'bold'"
                            class="w-4 h-4"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                        >
                            <path fill="none" d="M0 0H24V24H0z"/>
                            <path d="M21 4L21 6 20 6 14 15 14 22 10 22 10 15 4 6 3 6 3 4z"/>
                        </svg>
                        <svg
                            v-else
                            class="w-4 h-4" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                            height="24"
                        >
                            <path fill="none" d="M0 0H24V24H0z"/>
                            <path d="M21 4v2h-1l-5 7.5V22H9v-8.5L4 6H3V4h18zM6.404 6L11 12.894V20h2v-7.106L17.596 6H6.404z"/>
                        </svg>
                    </span>
                    <select
                        v-model="filters[fieldName]"
                        :id="fieldName"
                        :name="fieldName"
                        class="block pl-9 w-full text-sm rounded border-gray-300 transition-shadow focus:ring-0 focus:border-gray-400 capitalize"
                    >
                        <option v-for="(option) in filter.select_options"
                                :key="'option-' + option.value"
                                :selected="option === filter.default_value"
                                :value="option.value"
                        >
                            {{ option.label }}
                        </option>
                    </select>
                </div>
            </div>
        <!-- ./ select -->
        <!-- range datepicker -->
        <div
            v-if="filter.type === 'range_datepicker'"
            class="inline-flex relative md:col-span-3 xl:col-span-5"
        >

            <date-range-picker
                @date-changed="assignDatesToFilterVars"
                :date_from="filter.date_from"
                :date_to="filter.date_to"
                class="flex-1"
            />
            <div
                class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none text-opacity-50"
                :class="'text-' + isCustomColor(layoutOptions.text_color) ? 'custom-text' : layoutOptions.text_color"
            >
                <svg
                    v-if="layoutOptions.icons === 'bold'"
                    class="w-4 h-4"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path fill="none" d="M0 0h24v24H0z"/>
                    <path d="M2 11h20v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9zm15-8h4a1 1 0 0 1 1 1v5H2V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2z"/>
                </svg>
                <svg
                    v-else
                    class="w-4 h-4"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path fill="none" d="M0 0h24v24H0z"/>
                    <path d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm-2 2H9v2H7V5H4v4h16V5h-3v2h-2V5zm5 6H4v8h16v-8z"/>
                </svg>
            </div>

        </div>
        <!-- ./ range datepicker -->
        </template>

        <div class="bg-opacity-100">

            <btn
                class="w-full"
                icon-name="search"
                :type="isCustomColor(layoutOptions.button_color) ? 'custom' : layoutOptions.button_color"
                @click="fetchData"
            />

        </div>
        <validation-errors
            :errors="validationErrors"
            class="mt-2.5 col-span-full"
        />
    </div>
</template>

<script>
import useFiltersAndPagination from '../../../../state/common/filters-and-pagination'
import {isCustomColor, setFilterFields} from "../../../../helpers/common";
import {onMounted, reactive, ref, watch} from "vue";
import useFilters from "../../../../state/common/filters-and-pagination";
import useTranslationSettings from "../../../../state/portal/portal-translation-settings";
import ValidationErrors from "../../../common/ValidationErrors.vue";

export default {
    name: "TableFilter",
    components: {ValidationErrors},
    props: {
        filterList: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            dates: null
        }
    },
    setup(props) {
        let searchQuery = ref('')
        let filters = reactive({})

        const filterList = props.filterList
        const {layoutOptions} = useFiltersAndPagination()
        const { portalTranslationSettings } = useTranslationSettings()

        onMounted(() => {
            setFilterFields(filters, filterList)
        })

        const assignDatesToFilterVars = (dates) => {
            filters.date_from = dates.dateFrom
            filters.date_to = dates.dateTo
        }

        const {
            fetchDataBaseUrl,
            fetchDataFunction,
            setFilters: setFiltersToStore,
            setSearchParam: setSearchParamToStore,
            validationErrors
        } = useFilters()

        function fetchData() {
            fetchDataFunction.value(fetchDataBaseUrl.value, {...filters, search: searchQuery.value})
        }

        watch(filters, (updatedFilters) => {
            setFiltersToStore(updatedFilters)
            fetchData();
        })

        watch(searchQuery, () => {
            setSearchParamToStore(searchQuery.value)
        })

        return {
            filters,
            layoutOptions,
            searchQuery,
            assignDatesToFilterVars,
            fetchData,
            portalTranslationSettings,
            validationErrors
        }
    },
    methods: {
        isCustomColor
    }
}
</script>
